import {
  PROCESSING,
  GET_RESOURCES,
} from '../actions/resourcePlanner/resourcePlanner.actiontype';

const initialState = {
  isProcessing: false,
  resources: [],
};

const ResourcePlanner = (state = initialState, action) => {
  switch (action.type) {
    case PROCESSING: {
      if (state.resources.length > 0 && action.payload) {
        return state;
      } else {
        return {
          ...state,
          isProcessing: action.payload,
        };
      }
    }

    case GET_RESOURCES: {
      return {
        ...state,
        types: action.payload,
      };
    }

    default:
      return state;
  }
};

export default ResourcePlanner;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
